import { AlertSettings } from '../../../models/ops/vtpass.model';
import { useGet, useSend } from '../../useApi';

// GET / PUT /admin/vtpass/alert-settings (used from the next balance check on).
const useVtpassAlertSettings = () => {
  const { data, loading, fetch, setData } = useGet<AlertSettings>('Failed to load the VTpass alert settings');
  const { loading: saving, send } = useSend<AlertSettings>('Could not save');
  return {
    settings: data,
    loading,
    saving,
    fetchSettings: () => fetch('api/v1/admin/vtpass/alert-settings'),
    save: (values: Record<string, number>, onDone?: () => void) =>
      send({ url: 'api/v1/admin/vtpass/alert-settings', method: 'put', data: { values } }, (body) => {
        setData(body);
        onDone?.();
      }),
  };
};

export default useVtpassAlertSettings;
